import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Feeds } from 'src/app/models/feeds';
import { User } from 'src/app/models/user';
import { LoaderService } from 'src/app/service/loaderService';
import { MessageService } from 'src/app/service/messageService';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {


  constructor(
    private router:Router,
    private http: HttpClient,
    private tostr:MessageService,
    private loader:LoaderService,
    public matDialog: MatDialog,
  ) { }

  userList:User[]=[]
  total:number = 100;
  skip:number = 0;
  limit:number = 25;
  dialogRef: any;
  displayColumns=["firstName","lastName","email","birthDate","createdDate","userType","action"]
  
  userTypes=["Admin","User"];
  ngOnInit(): void {

        this.getFeedsList();
  }

  addNewFeed(){
       this.router.navigateByUrl("add_feed/-1")
  }

 

  editFeed(id:string){
     this.router.navigateByUrl("add_feed/"+id)
  }

  //Object { previousPageIndex: 3, pageIndex: 2, pageSize: 10, length: 100 }




  getFeedsListCall() {
    return this.http.get("https://zkkrb2x445ze3u77k6ukx3cdr40nnzwc.lambda-url.us-west-1.on.aws/");
  }

  getFeedsList() {
    // let id = "asasas"
    // this.loader.start(id);
    this.getFeedsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;

       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
        this.userList = listData;
        this.total = listData.length;
          // this.tostr.success("data retrived successfully")
          // this.loader.stop(id);
      });
  }


  getList(event:any){
    this.skip = event.pageIndex * event.pageSize;
    this.limit = event.pageSize;
    console.log(this.skip )
    console.log(this.limit)
    this.getFeedsList();
}

  getTotalCount(){

  }


  userTypeChangedCall(questId:any) {
    // TODO: Add Url here
    return this.http.get("https://bnd54sokvha62h3fpnoykqnncu0qeovx.lambda-url.us-west-1.on.aws?param1=" + questId);
  }

  userTypeChanged(userType : any,item:any){
  
    let newtype:any;
    let oldtype:any;

    if(userType == this.userTypes[0]){
      newtype = this.userTypes[0];
      oldtype = this.userTypes[1];
    } else{
      newtype = this.userTypes[1];
      oldtype = this.userTypes[0];
    }

this.dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
  width: '300px',
  height: '200px',
  disableClose: true,
  data: {
    title: 'Confirmation',
    subject: 'Are you sure you want to change this '+oldtype +' to '+newtype+'?',
    submitButton: 'Proceed',
    cancelButton: 'Cancel'
  }
})
this.dialogRef.afterClosed().subscribe((result: any) => {
  if(result) {
    this.userTypeChangedCall(item.id).subscribe(data => {
       let responce : any = data;
       this.tostr.success("Data Updates Successfully");
       this.getFeedsList();
    });
  } else {
    item.userType = oldtype;
  }
});

  }

  deleteFeedCall(questId:any) {
  // TODO: Add Url here
  return this.http.get("https://uvqnrijuxhz2epovumxhniasw40zukpg.lambda-url.us-west-1.on.aws?param1=" + questId);
}



ChangeState(item:any,state:boolean) {

  let status = "Active";
  if(!state){
    status = "InActive";
  }
  this.dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
    width: '300px',
    height: '200px',
    disableClose: true,
    data: {
      title: 'Confirmation',
      subject: 'Are you sure you want to '+status+'This User?',
      submitButton: 'Proceed',
      cancelButton: 'Cancel'
    }
  })
  this.dialogRef.afterClosed().subscribe((result: any) => {
    if(result) {
      this.deleteFeedCall(item.id).subscribe(data => {
         let responce : any = data;
         this.tostr.success("Data Updates Successfully");
         this.getFeedsList();
      });
    } else {
      item.isActive = !state;
    }
  });
}

}
